import React from "react";
import './BuiltInTests.scss';

import { calculateAverageDuration, calculateAccuracy, calculateAverageAccuracy, 
  calculateRawWPM, calculateAverageWPM, 
  calculateCorrectWPM, calculateAverageCorrectWPM } from "./resources/TypingTestCalcs";

function DisplayTypingResults(props){
  const sentences = props.sentences || [];
  return(
    <div>
    {(sentences.length > 0) 
      ? 
      <>
      <h2>Activity Complete! Good job!</h2>
      <div className="aa-review-row"> 
        <p><strong>Speed: </strong>{calculateAverageCorrectWPM(sentences).toFixed(1) + ' words/min'}</p>
        <p><strong>Accuracy: </strong>{calculateAverageAccuracy(sentences).toFixed(0) + '%'}</p>
      </div>
      <table className="aa-test-table">
        <thead>
          <tr>
            <th>Sentence</th>
            <th>Time Taken (sec)</th>
            <th>Raw Speed (WPM)</th>
            <th>Correct Speed (WPM)</th>
            <th>Accuracy (%)</th>
          </tr>
        </thead>
        <tbody>
          {sentences.map((s, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td><PrettyPrint numberStr={(s.duration / 1000).toFixed(1)} /></td>
              <td><PrettyPrint numberStr={calculateRawWPM(s).toFixed(1)} /></td>
              <td><PrettyPrint numberStr={calculateCorrectWPM(s).toFixed(1)} /></td>
              <td><PrettyPrint numberStr={calculateAccuracy(s).toFixed(0)} /></td>
            </tr>
          ))}
          <tr className="average-row" key={sentences.length + 1}>
            <td>Average</td>
            <td><PrettyPrint numberStr={(calculateAverageDuration(sentences)/1000).toFixed(1)} /></td>
            <td><PrettyPrint numberStr={calculateAverageWPM(sentences).toFixed(1)} /></td>
            <td><PrettyPrint numberStr={calculateAverageCorrectWPM(sentences).toFixed(1)} /></td>
            <td><PrettyPrint numberStr={calculateAverageAccuracy(sentences).toFixed(1)} /></td>
          </tr>
        </tbody>
      </table>
      </>
      :
      <p>There are no data to display.</p>
    }
    </div>
  );
}

function PrettyPrint(props){
  const numberStr = props.numberStr;
  if (numberStr && ((numberStr==='NaN') || (numberStr==='Infinity'))){
    return("-");
  }
  else return(numberStr);
}

export default DisplayTypingResults;
